module.exports = __webpack_public_path__ + "static/media/D-flat-Triads.2a793fd3.png";